import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, Events } from 'ionic-angular';
import { JobDetailsPage } from '../job-search/components/job-details/job-details.component';
import { ProfileService } from '../../../../../UI/src/app/shared/profile/profile.service';
import { GeoLocationService } from '../../../../../UI/src/app/shared/location/geo-location.service';
import { Storage } from '../../../../../UI/src/app/shared/constants';
import { JobAlertComponent } from '../job-alert/job-alert.component';
import { AddResumeComponent } from '../authentication/components/add-resume/add-resume.component';
import { EditProfileComponent } from '../edit-profile/edit-profile.component';
import { ToastControllerService } from '../../../providers/toast-controller.service';
import { JobAlertService } from '../../../../../UI/src/app/shared/job-alert/job-alert.service';
import { ResumeService } from '../../../../../UI/src/app/shared/resume/resume.service';
import { Toast508Service } from '../../../providers/toast-508.service';
import { ActionSheetController, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../../../UI/src/app/shared/authentication/authentication.service';
import { SigninComponent } from '../../modules/authentication/components/signin/signin.component';

import * as _ from 'lodash';


@Component({
  selector: 'page-candidate-profile',
  templateUrl: 'candidate-profile.component.html'
})
export class CandidateProfileComponent {

  jobDetailsPage: any = JobDetailsPage;
  jobAlertComponent: any = JobAlertComponent;
  addResumeComponent: any = AddResumeComponent;
  tabSelected = 'matches';
  loadingPopup: any;
  jobApplied: boolean = false;
  infiniteScrollEnabled = true; // TODO Implement infinute scroll
  profileData: any = {};
  personNumber = '';
  favoriteJobs = [];
  pagedFavoriteJobs = [];
  appliedJobs = [];
  JobAlertdata = [];
  pagedAppliedJobs = [];
  sortFields = [];
  matchedJobs = [];
  deltaMatchedJobs = [];
  machedJobsCount = 0;
  coords;
  locationFilter;
  sortFilter = { 'SortField': 'score', 'SortDirection': 'desc' };
  selectedSortField = 'CAREER_SORT_BEST_MATCH';
  alertData: any = null;
  showAlert = false;
  startRow = 0;
  pageSize = 10;
  resumeTypeClass;
  resumeType: number = 0;
  goToThirdStep: boolean = true;
  candidateTranslations: any;
  public isLoggedIn = false;  
  showJobAlert = false;
  constructor(
    public navCtrl: NavController,
    
    
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private profileService: ProfileService,
    private jobAlertService: JobAlertService,
    private geoLocationService: GeoLocationService,
    private toastService: ToastControllerService,
    private toast508Service: Toast508Service,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    private resumeService: ResumeService,
    private authenticationService: AuthenticationService,
    public events: Events,
  ) {
    this.isLoggedIn = this.authenticationService.isUserLoggedin();
    this.events.publish('showSiteMapNodes', true);
    this.translate.get(['CAREER_FAILED_MESSAGE']).subscribe((obj) => {
      this.candidateTranslations = obj;
    });
    if (navParams.data) {
      this.jobApplied = navParams.data;
    }
    this.showJobAlert = jobAlertService.isJobAlertEnabled();
  }

  ionViewDidLoad() {
  }

  ionViewWillEnter() {
    if(!this.isLoggedIn){    
      this.navCtrl.setRoot(SigninComponent);
    } 
    else{
      this.getProfileData();
      this.getSortFields();
      this.getFavoriteJobs();
      this.getAppliedJobs();
      this.getJobAlerts();
    }
  }


  onFetchMoreMatchedJobs(event) {
    // TODO : Implement infinite scrolling
    let tempJobs = [];
    tempJobs = this.matchedJobs;
    this.startRow = this.startRow + this.pageSize;
    this.getMatchedJobs();
  }

  getProfileData() {
    this.profileService.getProfileData().subscribe(
      (response) => {
        this.profileData = response[0];
        this.profileData.address = this.concatStrings([this.profileData.city, this.profileData.state], ', ');
        this.resumeType = this.profileData.resumeType;
        switch (this.resumeType) {
          case 1:
            this.resumeTypeClass = 'fa-info';
            break;
          case 2:
            this.resumeTypeClass = 'fa-linkedin-square';
            break;
          case 3:
            this.resumeTypeClass = 'fa-file-text';
            break;
        }
        if (this.profileData.imagePath && !this.profileData.imagePath.match(/^(https?:\/\/)/gi)) {
          this.profileData.imagePath = window.localStorage.getItem(Storage.DATASTORE) + 'PersonImages/' + this.profileData.imagePath;
        }
        this.getCandidateProfileJobsData();
      }, (error) => {
        // TODO : Implement alert
      }
    );
  }


  concatStrings(inputString, concatChar) {
    let outputString = [];
    inputString.forEach(element => {
      if (element) {
        outputString = outputString.concat(element.trim());
      }
    });
    return outputString.join(concatChar);
  }

  getCandidateProfileJobsData() {
    if(this.matchedJobs.length ==0) {
      this.getMatchedJobs();
    }
    this.getSortFields();
  }

  selectTab(tabID) {
    if (tabID !== this.tabSelected) {
      this.tabSelected = tabID;
      this.selectedSortField='CAREER_SORT_BEST_MATCH';
      if (tabID === 'matches') {
        this.matchedJobs.length = 0;
        this.getMatchedJobs();
      } else if (tabID === 'favorites') {
        this.getFavoriteJobs();
      } else if (tabID == 'alerts') {
        this.selectedSortField='';
        this.getJobAlerts();
      } else {
        this.getAppliedJobs();
      }
    }
  }

  getMatchedJobs() {
    this.infiniteScrollEnabled = true;
    const searchRequest = {
      'SearchText': '*',
      'StartRow': this.startRow,
      'PageCount': this.pageSize,
      'Contexts': ['publicjob'],
      'Filters': [],
      'SortFilters': [this.sortFilter]
    };

    if (this.coords) {
      this.locationFilter = {
        'name': 'Distance',
        'searchFieldName': 'GeoLocation',
        'value': this.coords.latitude + ',' + this.coords.longitude,
        'uncodedValue': this.coords.latitude + ',' + this.coords.longitude
      };
      const sortObj = { SortField: 'Distance_Sortable', SortDirection: 'asc' };
      searchRequest.Filters.push(this.locationFilter);
      searchRequest.SortFilters.push(sortObj);
    }

    if (this.resumeType !== 0) {
      this.profileService.getMatchedJobs(searchRequest).subscribe(
        (response) => {
          if (response) {
            this.matchedJobs = response.resultItems.searchResults;
            this.machedJobsCount = response.binCount;
            this.infiniteScrollEnabled = false;
          }
        }, (error) => {
          this.alertData = { message: 'Failed to get matched jobs', type: 'error' };
          this.toastService.presentToast(this.alertData);
          this.toast508Service.toFocus();
          this.infiniteScrollEnabled = false;
        }
      );
    } else {
      this.infiniteScrollEnabled = false;
      this.alertData = {
        message: 'There are no top matches because you have not linked resume. Click the Get Matched button to' +
        'link or upload your resume.', type: 'warning'
      };
      this.toastService.presentToast(this.alertData);
      this.toast508Service.toFocus();
    }
  }

  getFavoriteJobs() {
    this.profileService.getFavoriteJobs().subscribe(
      (response) => {
        this.favoriteJobs = this.applySortFilters(response);
        this.pagedFavoriteJobs = this.favoriteJobs.slice(0, this.pageSize);
      }, (error) => {
        this.alertData = { message: this.candidateTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
        this.toastService.presentToast(this.alertData, 'btnfavorites');
        this.toast508Service.toFocus();
        this.showAlert = true;
      }
    );
  }

  getAppliedJobs() {
    this.profileService.getAppliedJobs().subscribe(
      (response) => {
        this.appliedJobs = this.applySortFilters(response);
        this.pagedAppliedJobs = this.appliedJobs.slice(0, this.pageSize);
      }, (error) => {
        this.alertData = { message: this.candidateTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
        this.toastService.presentToast(this.alertData, 'btnApplied');
        this.toast508Service.toFocus();
        this.showAlert = true;
      }
    );
  }

  getJobAlerts() {
    this.jobAlertService.getJobAlerts().then(
      (response) => {
        this.JobAlertdata = response;
        
      }, (error) => {
        this.alertData = { message: this.candidateTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
        this.toastService.presentToast(this.alertData);
        this.toast508Service.toFocus();
        this.showAlert = true;
      }
    );
  }

  openJobDetails(jobData) {
    this.navCtrl.push(this.jobDetailsPage, jobData);
  }

  onFavPageChange(index) {
    this.pagedFavoriteJobs = this.favoriteJobs.slice(index, index + this.pageSize);
  }

  onAppliedPageChange(index) {
    this.pagedAppliedJobs = this.appliedJobs.slice(index, index + this.pageSize);
  }

  getSortFields() {
    this.profileService.getSortFields().subscribe(
      (response) => {
        this.sortFields = response;
      }, (error) => {
      }
    );
  }

  filterMatchedJobs(selectedFilter) {
    if(this.selectedSortField === 'CAREER_SORT_BEST_MATCH')
    {

      this.sortFilter={'SortField': 'score', 'SortDirection': 'desc' };
    }
    else {
    const sortObj = this.sortFields.filter(item => item.displayName === this.selectedSortField)[0];
    this.sortFilter = { 'SortField': sortObj.sortFieldName, 'SortDirection': sortObj.sortDirection };
    }
    this.getMatchedJobs();
  }

  onEditProfile() {
    this.resumeService.setResumeAction({ action: 'EDIT_RESUME', isInititalCreation: false });
    this.navCtrl.push(EditProfileComponent);
  }

  onGetMatched() {
    this.navCtrl.push(this.addResumeComponent, this.goToThirdStep);
  }

  jobAlert() {
    
    this.navCtrl.push(this.jobAlertComponent);
  }
  onImageError() {
  }


  presentActionSheet(jobAlert) {
    this.navCtrl.push(this.jobAlertComponent, jobAlert);
  }
  filterFavoriteJobs(selectedFilter) {
    this.profileService.getFavoriteJobs().subscribe(
      (response) => {
        this.favoriteJobs = this.applySortFilters(response);
        this.pagedFavoriteJobs = this.favoriteJobs.slice(0, this.pageSize);
      }, (error) => {
        this.alertData = { message: this.candidateTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
        this.toastService.presentToast(this.alertData, 'btnfavorites');
        this.toast508Service.toFocus();
        this.showAlert = true;
      }
    );
  }
  filterAppliedJobs() {
    this.profileService.getAppliedJobs().subscribe(
      (response) => {
        this.appliedJobs = this.applySortFilters(response);
        this.pagedAppliedJobs = this.appliedJobs.slice(0, this.pageSize);
      }, (error) => {
        this.alertData = { message: this.candidateTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
        this.toastService.presentToast(this.alertData, 'btnApplied');
        this.toast508Service.toFocus();
        this.showAlert = true;
      }
    );
  }
  private applySortFilters(resultJobs)
  {
    const sortObj = this.sortFields.filter(item => item.displayName === this.selectedSortField)[0];
    if(this.selectedSortField === 'CAREER_SORT_BEST_MATCH')
    {
        resultJobs= _.orderBy(resultJobs,'percentageMatch','desc');
    }
    else if(sortObj.sortFieldName === 'ExternalTitle_Sortable')
    {
        if(sortObj.sortDirection === 'asc')
        resultJobs= _.orderBy(resultJobs,['externalTitle','percentageMatch'],['asc','desc']);
        else 
        resultJobs= _.orderBy(resultJobs,['externalTitle','percentageMatch'],['desc','desc']);
    }
    else if(sortObj.sortFieldName === 'Ext_PostingDate_Sortable')
    {
        if(sortObj.sortDirection === 'asc')
        resultJobs= _.orderBy(resultJobs,['ext_PostingDate','percentageMatch'],['asc','desc']);
        else 
        resultJobs= _.orderBy(resultJobs,['ext_PostingDate','percentageMatch'],['desc','desc']);
    }
    else if(sortObj.sortFieldName === 'Category')
    {
        if(sortObj.sortDirection === 'asc')
        resultJobs= _.orderBy(resultJobs,['category','percentageMatch'],['asc','desc']);
        else 
        resultJobs= _.orderBy(resultJobs,['category','percentageMatch'],['desc','desc']);
    }
    else if(sortObj.sortFieldName === 'City_Sortable')
    {
        if(sortObj.sortDirection === 'asc')
        resultJobs= _.orderBy(resultJobs,['city','percentageMatch'],['asc','desc']);
        else 
        resultJobs= _.orderBy(resultJobs,['city','percentageMatch'],['desc','desc']);
    }
    return resultJobs;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/candidate-profile/candidate-profile.component.ts